var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"knob",style:(_vm.knobStyle),on:{"mousedown":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.selectGradientColor($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }